import { Component } from '@angular/core';

@Component({
  selector: 'prof-tos-view',
  templateUrl: './tos-view.component.html',
  styleUrls: ['./tos-view.component.scss'],
  standalone: false
})
export class TosViewComponent {
  constructor() {}
}
